import { ReactElement } from 'react';

import { DashboardVariantV2GiverContentActionsContainer } from '../../../../styles';

import DashboardVariantV2GiverContentFinalizedTabActionsFilters from './Filters';
import DashboardVariantV2GiverContentFinalizedTabActionsActionables from './Actionables';

const DashboardVariantV2GiverContentFinalizedTabActions = (): ReactElement => {
  return (
    <DashboardVariantV2GiverContentActionsContainer justifyContent="space-between">
      <DashboardVariantV2GiverContentFinalizedTabActionsFilters />

      <DashboardVariantV2GiverContentFinalizedTabActionsActionables />
    </DashboardVariantV2GiverContentActionsContainer>
  );
};

export default DashboardVariantV2GiverContentFinalizedTabActions;
